import gql from 'graphql-tag'

export const NOTIFY_REMOVE_RECENT_SEARCHES = gql`
  mutation NotifyRemoveRecentSearches($phrase: String!, $removeAll: Boolean!) {
    notifyRemoveRecentSearches(phrase: $phrase, removeAll: $removeAll)
  }
`
